import { promotions as AT } from './retail/AT';
import { promotions as CZ } from './retail/CZ';
import { promotions as HR } from './retail/HR';
import { promotions as HU } from './retail/HU';
import { promotions as RO } from './retail/RO';
import { promotions as SK } from './retail/SK';
import { promotions as RS } from './retail/RS';
import { promotions as ATbusiness } from './business/AT';
import { promotions as CZbusiness } from './business/CZ';
import { promotions as RObusiness } from './business/RO';
import { promotions as SKbusiness } from './business/SK';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};

export const businessFeatureMap = {
    AT: ATbusiness,
    CZ: CZbusiness,
    RO: RObusiness,
    SK: SKbusiness,
};
